module.exports = __webpack_public_path__ + "img/evaluate_active_8.6b2297fd.png";